module.exports = __webpack_public_path__ + "img/box-seam.02c12eba.svg";